export default __webpack_public_path__ + "static/media/gallery_15.73a9c0c8.jpg";